// import { createSelector } from 'reselect';
/* eslint-disable import/prefer-default-export */

export const getPersonalData = (state) => state.app.userData;
export const getPersonalDataLoading = (state) => (!!state.app.userData.email);
export const getPersonalDataCity = (state) => state.app.userData.city;

export const getAccessToken = (state) => (state.oidc.user ? state.oidc.user.access_token : '');